/**
 * @Author Valon.Ye
 * @Date 2023/01/10 14:04:08
 * @FilePath \commerce\src\pages\Product\Category\models\active-category.ts
 * @Description
 */
import { useState, useCallback, useMemo } from 'react'
import type { ReactText } from 'react'
import type { DataNode } from 'antd/lib/tree'
import { CategoryControllerApiParamCreator } from '@/api-auto-gen/productManagement'
import type { CategoryTreeNodeResponse } from '@/api-auto-gen/productManagement'
import { findNode, aliasArrayStructureFieldName } from '@/pages/Product/utils/array-tools'

import { useFetch } from '@/utils/hooks'

type ICategoryNode = CategoryTreeNodeResponse &
  Partial<DataNode> & { label?: string; key: ReactText }

findNode.findName = 'category_id'
findNode.nextPointName = 'child_categories'

const useActiveCategory = () => {
  const [activeCategory, setActiveCategory] = useState<ICategoryNode | null>(null)

  const {
    loading: categoryTreeLoading,
    data: categoryTreeData,
    run: categoryTreeFetch,
    error: categoryTreeError,
  } = useFetch<BasicResponse<CategoryTreeNodeResponse>>(
    CategoryControllerApiParamCreator.getAllCategory(),
    {
      manual: true,
      // @ts-ignore
      onError(error, _, defaultErrorHandler) {
        // 没有权限
        if (error?.code === '401101001') {
          return
        }
        defaultErrorHandler?.()
      },
    },
  )

  const treeData = useMemo(() => {
    const data = categoryTreeData?.child_categories
    if (!data?.length) return []
    aliasArrayStructureFieldName.nextPointName = 'child_categories'
    const result = aliasArrayStructureFieldName<CategoryTreeNodeResponse, ICategoryNode>(data, {
      category_id: ['key', 'value'],
      category_name: 'title',
      label(node) {
        const label = node.category_name
        // if (parent) {
        //   label = `${parent.label}/${label}`
        // }
        return label
      },
    })
    return result
  }, [categoryTreeData])

  const activeCategoryParent = useMemo<ICategoryNode | null>(() => {
    if (!activeCategory?.parent_category_id || !treeData?.length) return null
    let parentCategory: ICategoryNode | null = null
    findNode.findName = 'category_id'
    findNode.nextPointName = 'child_categories'
    findNode(treeData, activeCategory?.parent_category_id!, (isFind, item) => {
      if (!isFind) return
      parentCategory = item as ICategoryNode
    })
    return parentCategory
  }, [activeCategory, treeData])

  const updateActiveCategory = useCallback(
    (categoryNode: ICategoryNode | null) => {
      setActiveCategory(categoryNode)
    },
    [setActiveCategory],
  )

  return {
    activeCategory,
    activeCategoryParent,
    categoryTreeLoading,
    categoryTreeError,
    treeData,
    categoryTreeData,
    categoryTreeFetch,
    updateActiveCategory,
  }
}

export type { ICategoryNode }

export default useActiveCategory
